(function () {
  var root = document.documentElement;
  var body = null;
  var unlockTimer = null;
  var safetyTimer = null;
  var observer = null;
  var actionSelector = '[data-sale-purchase-action], [data-sale-checkout-action], .product__actions, .product-bar__actions, .bsr-product-rail__drawer-actions, .cart-drawer__upsell-item-actions, .cart-summary__checkout, .cart__dynamic-checkout-buttons, .additional-checkout-buttons, .card-product__quickbuy, .card-product__quickbuy-options';
  var buttonSelector = 'button[name="add"], button[name="checkout"], input[name="checkout"], button.product__submit, button.product-bar__submit, .shopify-payment-button button, .shopify-payment-button__button, [data-bsr-look-add-to-cart], [data-bsr-look-buy-now] button';

  function getBody() {
    body = body || document.body;
    return body;
  }

  function isEnabled() {
    var el = getBody();
    return !!el && el.getAttribute('data-bsr-sale-lock-enabled') === 'true';
  }

  function isForceUnlocked() {
    var el = getBody();
    return !!el && el.getAttribute('data-bsr-sale-lock-force-unlock') === 'true';
  }

  function unlockAt() {
    var el = getBody();
    if (!el) return NaN;
    return Date.parse(el.getAttribute('data-bsr-sale-lock-unlock-at') || '');
  }

  function shouldLock() {
    if (!isEnabled() || isForceUnlocked()) return false;
    var releaseAt = unlockAt();
    if (Number.isNaN(releaseAt)) return true;
    return Date.now() < releaseAt;
  }


  function isCheckoutUrl(url) {
    if (!url) return false;
    var parsed;
    try {
      parsed = new URL(url, window.location.origin);
    } catch (error) {
      return false;
    }
    return parsed.pathname.indexOf('/checkout') !== -1;
  }
  function setButtonsLocked(locked) {
    document.querySelectorAll(buttonSelector).forEach(function (button) {
      if (!(button instanceof HTMLElement)) return;
      if (locked) {
        if (!button.hasAttribute('data-sale-lock-original-disabled')) {
          button.setAttribute('data-sale-lock-original-disabled', button.disabled ? 'true' : 'false');
        }
        button.disabled = true;
        button.setAttribute('aria-disabled', 'true');
      } else if (button.hasAttribute('data-sale-lock-original-disabled')) {
        var originallyDisabled = button.getAttribute('data-sale-lock-original-disabled') === 'true';
        if (!originallyDisabled) button.disabled = false;
        button.removeAttribute('aria-disabled');
        button.removeAttribute('data-sale-lock-original-disabled');
      }
    });
  }

  function applyState() {
    var locked = shouldLock();
    root.classList.toggle('bsr-sale-purchase-locked', locked);
    if (getBody()) getBody().classList.toggle('bsr-sale-purchase-locked', locked);
    setButtonsLocked(locked);
    scheduleUnlockCheck();
    return locked;
  }

  function scheduleUnlockCheck() {
    window.clearTimeout(unlockTimer);
    window.clearInterval(safetyTimer);
    if (!isEnabled() || isForceUnlocked()) return;
    var releaseAt = unlockAt();
    if (!Number.isNaN(releaseAt)) {
      var delay = Math.max(0, Math.min(releaseAt - Date.now(), 2147483647));
      unlockTimer = window.setTimeout(applyState, delay + 250);
    }
    safetyTimer = window.setInterval(applyState, 30000);
  }

  function blockIfLocked(event) {
    if (!shouldLock()) return;
    var target = event.target;
    if (!(target instanceof Element)) return;

    var link = target.closest('a[href]');
    if (link && isCheckoutUrl(link.getAttribute('href'))) {
      event.preventDefault();
      event.stopImmediatePropagation();
      return;
    }

    if (event.type === 'submit') {
      var form = target.closest('form');
      var submitter = event.submitter;
      var submitsCheckout = submitter && submitter.getAttribute && submitter.getAttribute('name') === 'checkout';
      if (form && (isCheckoutUrl(form.getAttribute('action')) || submitsCheckout || form.querySelector('[name="checkout"]'))) {
        event.preventDefault();
        event.stopImmediatePropagation();
        return;
      }
    }

    var purchaseTarget = target.closest(actionSelector + ', ' + buttonSelector + ', form[action*="/cart/add"], form[action*="/checkout"]');
    if (!purchaseTarget) return;
    event.preventDefault();
    event.stopImmediatePropagation();
  }

  function startObserver() {
    if (observer) return;
    observer = new MutationObserver(function () {
      if (shouldLock()) setButtonsLocked(true);
    });
    observer.observe(document.documentElement, { childList: true, subtree: true });
  }

  document.addEventListener('click', blockIfLocked, true);
  document.addEventListener('submit', blockIfLocked, true);
  document.addEventListener('visibilitychange', applyState);
  window.addEventListener('pageshow', applyState);
  document.addEventListener('DOMContentLoaded', function () {
    applyState();
    startObserver();
  });

  window.BSRSalePurchaseLock = {
    refresh: applyState,
    isLocked: shouldLock
  };
})();